import { IDateEntry } from "@lib/types";
import { EPeriodTypes } from "./exception.types";
import { TErrorField } from "./exception-form-helper";
import i18next from "i18next";

export const getSelectOptions = () => ({
  dayOfWeek: [
    { text: i18next.t($ => $.scheduleBacnet.anyWeekDay), value: "*" },
    { text: i18next.t($ => $.scheduleBacnet.monday), value: "1" },
    { text: i18next.t($ => $.scheduleBacnet.tuesday), value: "2" },
    { text: i18next.t($ => $.scheduleBacnet.wednesday), value: "3" },
    { text: i18next.t($ => $.scheduleBacnet.thursday), value: "4" },
    { text: i18next.t($ => $.scheduleBacnet.friday), value: "5" },
    { text: i18next.t($ => $.scheduleBacnet.saturday), value: "6" },
    { text: i18next.t($ => $.scheduleBacnet.sunday), value: "7" },
  ],
  dayOfMonth: [
    { text: i18next.t($ => $.scheduleBacnet.anyDayOfMonth), value: "**" },
    { text: i18next.t($ => $.scheduleBacnet.lastDay), value: "32" },
    { text: i18next.t($ => $.scheduleBacnet.oddDays), value: "33" },
    { text: i18next.t($ => $.scheduleBacnet.evenDays), value: "34" },
    ...Array.from({ length: 31 }, (_, i) => ({
      text: `${i + 1}`,
      value: (i + 1).toString(),
    })),
  ],
  month: [
    { text: i18next.t($ => $.scheduleBacnet.anyMonth), value: "**" },
    { text: i18next.t($ => $.scheduleBacnet.evenMonths), value: "14" },
    { text: i18next.t($ => $.scheduleBacnet.oddMonths), value: "13" },
    { text: i18next.t($ => $.scheduleBacnet.january), value: "1" },
    { text: i18next.t($ => $.scheduleBacnet.february), value: "2" },
    { text: i18next.t($ => $.scheduleBacnet.march), value: "3" },
    { text: i18next.t($ => $.scheduleBacnet.april), value: "4" },
    { text: i18next.t($ => $.scheduleBacnet.may), value: "5" },
    { text: i18next.t($ => $.scheduleBacnet.june), value: "6" },
    { text: i18next.t($ => $.scheduleBacnet.july), value: "7" },
    { text: i18next.t($ => $.scheduleBacnet.august), value: "8" },
    { text: i18next.t($ => $.scheduleBacnet.september), value: "9" },
    { text: i18next.t($ => $.scheduleBacnet.october), value: "10" },
    { text: i18next.t($ => $.scheduleBacnet.november), value: "11" },
    { text: i18next.t($ => $.scheduleBacnet.december), value: "12" },
  ],
  year: [
    { text: i18next.t($ => $.scheduleBacnet.anyYear), value: "****" },
    { text: i18next.t($ => $.scheduleBacnet.selected), value: "custom" },
  ],
  weekOptions: [
    { text: i18next.t($ => $.scheduleBacnet.anyWeek), value: "*" },
    { text: i18next.t($ => $.scheduleBacnet.firstWeek), value: "1" },
    { text: i18next.t($ => $.scheduleBacnet.secondWeek), value: "2" },
    { text: i18next.t($ => $.scheduleBacnet.thirdWeek), value: "3" },
    { text: i18next.t($ => $.scheduleBacnet.fourthWeek), value: "4" },
    { text: i18next.t($ => $.scheduleBacnet.fifthWeek), value: "5" },
    { text: i18next.t($ => $.scheduleBacnet.lastSevenDaysOfMonth), value: "6" },
  ],
});

export const formConfig = (initialData: IDateEntry) => ({
  [EPeriodTypes.DATE]: [
    {
      type: "dayOfWeek",
      id: "dayOfWeek",
      containerId: "dayOfWeekContainer",
      value: initialData?.start?.weekDay,
    },
    {
      type: "dayOfMonth",
      id: "dayOfMonth",
      containerId: "dayOfMonthContainer",
      value: initialData?.start?.day,
    },
    {
      type: "month",
      id: "month",
      containerId: "monthContainer",
      value: initialData?.start?.month,
    },
    {
      type: "year",
      id: "year",
      containerId: "yearContainer",
      value: initialData?.start?.year,
    },
  ],
  [EPeriodTypes.DATE_RANGE]: [
    {
      type: "dayOfWeek",
      id: "startDayOfWeek",
      containerId: "startDayOfWeekContainer",
      value: initialData?.start?.weekDay,
    },
    {
      type: "dayOfMonth",
      id: "startDayOfMonth",
      containerId: "startDayOfMonthContainer",
      value: initialData?.start?.day,
    },
    {
      type: "month",
      id: "startMonth",
      containerId: "startMonthContainer",
      value: initialData?.start?.month,
    },
    {
      type: "year",
      id: "startYear",
      containerId: "startYearContainer",
      value: initialData?.start?.year,
    },

    {
      type: "dayOfWeek",
      id: "endDayOfWeek",
      containerId: "endDayOfWeekContainer",
      value: initialData?.end?.weekDay,
    },
    {
      type: "dayOfMonth",
      id: "endDayOfMonth",
      containerId: "endDayOfMonthContainer",
      value: initialData?.end?.day,
    },
    {
      type: "month",
      id: "endMonth",
      containerId: "endMonthContainer",
      value: initialData?.end?.month,
    },
    {
      type: "year",
      id: "endYear",
      containerId: "endYearContainer",
      value: initialData?.end?.year,
    },
  ],
  [EPeriodTypes.WEEK_AND_DAY]: [
    {
      type: "dayOfWeek",
      id: "periodDayOfWeek",
      containerId: "periodDayOfWeekContainer",
      value: initialData?.start?.weekDay,
    },
    {
      type: "weekOptions",
      id: "periodWeek",
      containerId: "periodWeekContainer",
      value: initialData?.start?.week,
    },
    {
      type: "month",
      id: "periodMonth",
      containerId: "periodMonthContainer",
      value: initialData?.start?.month,
    },
  ],
  [EPeriodTypes.CAL_REF]: [
    {
      type: "input",
      id: "calendarId",
      containerId: "calendarIdContainer",
      value: "",
    },
  ],
});

export type TSelectHelper = ReturnType<typeof getSelectOptions>;

// Маппинг логических полей к физическим элементам формы
export const fieldMapping: Record<TErrorField, string[]> = {
  'day': ['startDayOfMonth', 'endDayOfMonth', 'dayOfMonth'],
  'month': ['startMonth', 'endMonth', 'month', 'periodMonth'],
  'year': ['startYear', 'endYear', 'year'],
  'weekDay': ['startDayOfWeek', 'endDayOfWeek', 'dayOfWeek', 'periodDayOfWeek'],
  'calendarId': ['calendarId'],
  '*': [] // все поля
};